export default [
    { // 공연전시
        path: 'play',
        children: [
            { // 프로그램 관리
                path: 'prfm-mng',
                redirect: { name: 'PrfmList' },
                children: [
                    {
                        path: 'list',
                        name: 'PrfmList',
                        meta: { menu: 'play', keepAlive: true },
                        component: () => import('@/pages/resvMng/play/PrfmListView.vue')
                    },
                    {
                        path: 'add',
                        name: 'PrfmInsert',
                        meta: { menu: 'play', keepAlive: false },
                        component: () => import('@/pages/resvMng/play/PrfmInsertView.vue'),
                        props: (route) => ({
                            ftrPrgrmDcd: route.query.ftrPrgrmDcd || ''
                        })
                    },
                    {
                        path: 'modify/:ftrPrgrmId',
                        name: 'PrfmUpdate',
                        meta: { menu: 'play', keepAlive: false },
                        component: () => import('@/pages/resvMng/play/PrfmUpdateView.vue'),
                        props: (route) => ({
                            ftrPrgrmDcd: route.query.ftrPrgrmDcd || '',
                            ftrPrgrmId: route.params.ftrPrgrmId || ''
                        })
                    }
                ]
            },
            
        ]
    },
]
